module.exports = __webpack_public_path__ + "img/Lisensi-DigiBos.7eef9c56.webp";